// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"285":"b99c837b","852":"74c87cc5","877":"b30931df","951":"dcce92c9"}[chunkId] + ".chunk.css";
};